import React from 'react';
import PropTypes from 'prop-types';
import {BlocksControls, InlineBlocks} from 'react-tinacms-inline';
import {align, box} from '../../constants/fields/fields';
import {Button} from './Button';
import {ButtonListStyled} from './ButtonListStyled';
import {useBlockProps} from '../../hooks/useBlockProps';
import {buttonsTemplate} from '../../constants/templates/button';


const BLOCKS = {
  button: Button,
};


function ButtonListComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  return (
    <BlocksControls index={index} focusRing={{offset: 10}}>
      <ButtonListStyled {...blockProps}>
        <InlineBlocks
          name="blocks"
          blocks={BLOCKS}
          direction={'horizontal'}
          className="dfl-image-list"
        />
      </ButtonListStyled>
    </BlocksControls>
  );
}

const template = {
  label: 'Button List',
  defaultItem: buttonsTemplate,
  fields: [
    {
      name: 'text',
      label: '',
      component: 'responsive-group',
      fields: [align]
    },
    box
  ]
};
export const Buttons = {
  Component: ButtonListComponent,
  template
};

ButtonListComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
